import type { FC } from "react";

import type { LoyaltyBadgeCopyConfig, LoyaltyPriceTagState } from "@product-details/components/ProductLoyaltyBlock";
import { ProductPrice } from "@product-details/components/ProductPrice";
import { useConsumablesProductDetailsContext } from "@product-details/providers/ConsumablesProductDetailsProvider";

import { useConsumablesProductData } from "../../hooks/useConsumablesProductData";

type ConsumablesProductPriceProps = {
  loyaltyPriceTagState?: LoyaltyPriceTagState;
  loyaltyBadgeCopy?: LoyaltyBadgeCopyConfig;
};

export const ConsumablesProductPrice: FC<ConsumablesProductPriceProps> = ({
  loyaltyPriceTagState,
  loyaltyBadgeCopy,
}) => {
  const { consumablesProductDetailsComponentData, currentMatrixItem } = useConsumablesProductDetailsContext();

  const { isProductDataLoading, discount, priceInformation } = useConsumablesProductData();

  return (
    <ProductPrice
      hideDiscountBadge={!consumablesProductDetailsComponentData.hasDiscountBadge}
      hideLoyaltyDiscountBadge={!consumablesProductDetailsComponentData.hasLoyaltyDiscountBadge}
      hideStrikethroughPrice={!consumablesProductDetailsComponentData.hasStrikethroughPrice}
      priceInformation={priceInformation}
      discount={discount}
      isFetching={isProductDataLoading}
      showMonthlyBadge={currentMatrixItem.purchaseType === "subscription"}
      loyaltyPriceTagState={loyaltyPriceTagState}
      loyaltyBadgeCopy={loyaltyBadgeCopy}
    />
  );
};
